enum EConnectSectionsMode {
  MainSections = 'MainSections',
  PreviewMainSections = 'PreviewMainSections',
  ClassesSections = 'ClassesSections',
  PreviewClassesSections = 'PreviewClassesSections',
  AppointmentsSections = 'AppointmentsSections',
  PreviewAppointmentsSections = 'PreviewAppointmentsSections',
  PackagesSections = 'PackagesSections',
  PreviewPackagesSections = 'PreviewPackagesSections',
  Colours = 'Colours'
}

export default EConnectSectionsMode;

export const SSections = Object.freeze(
  new Set<EConnectSectionsMode>([
    EConnectSectionsMode.MainSections,
    EConnectSectionsMode.AppointmentsSections,
    EConnectSectionsMode.ClassesSections,
    EConnectSectionsMode.PackagesSections
  ])
);

export const SPreviews = Object.freeze(
  new Set<EConnectSectionsMode>([
    EConnectSectionsMode.PreviewMainSections,
    EConnectSectionsMode.PreviewAppointmentsSections,
    EConnectSectionsMode.PreviewClassesSections,
    EConnectSectionsMode.PreviewPackagesSections,
    EConnectSectionsMode.Colours
  ])
);
